import { API_BASE_URL } from "../../constants/index";
import {
  CarrierConfiguration,
  CreateCarrierConfiguration,
  UpdateCarrierConfiguration,
} from "../../Models/CarrierConfiguration";
import { defaultFetchParam, FetchParam } from "../../Models/FetchParam";
import { buildAPIUrl } from "../../api/apiHelpers";
import HttpClient from "../../api/httpClient";
import { PaginatedResponse } from "../../Models/Pagination";

export class CarrierConfigurationsService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient();
  }

  all(
    params: FetchParam = defaultFetchParam
  ): Promise<PaginatedResponse<CarrierConfiguration>> {
    return this.httpClient.fetch<PaginatedResponse<CarrierConfiguration>>(
      buildAPIUrl(
        `${API_BASE_URL}/contract-service/carrier-configurations`,
        params
      ),
      { method: "GET" }
    );
  }

  get(id: string): Promise<CarrierConfiguration> {
    return this.httpClient.fetch<CarrierConfiguration>(
      `${API_BASE_URL}/contract-service/carrier-configurations/${id}`,
      { method: "GET" }
    );
  }

  create(
    carrierConfiguration: CreateCarrierConfiguration
  ): Promise<CarrierConfiguration> {
    return this.httpClient.fetch<CarrierConfiguration>(
      `${API_BASE_URL}/contract-service/carrier-configurations`,
      {
        method: "POST",
        body: JSON.stringify(carrierConfiguration),
      }
    );
  }

  edit(carrierConfiguration: UpdateCarrierConfiguration): Promise<any> {
    return this.httpClient.fetch<CarrierConfiguration>(
      `${API_BASE_URL}/contract-service/carrier-configurations/${carrierConfiguration.id}`,
      {
        method: "PUT",
        body: JSON.stringify(carrierConfiguration),
      }
    );
  }

  delete(id: string): Promise<any> {
    return this.httpClient.fetch<CarrierConfiguration>(
      `${API_BASE_URL}/contract-service/carrier-configurations/${id}`,
      {
        method: "DELETE",
      }
    );
  }
}
